// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.range input[type="range"]::-webkit-slider-thumb {
  width: 1.5rem;
  height: 1.5rem;
  background-color: #E7E0F0;
  border: 4px solid #4D2481;
  pointer-events: auto;
  cursor: pointer;
  border-radius: 9999px;
  -webkit-appearance: none; }

.range input[type="range"]::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #E7E0F0;
  border: 4px solid #4D2481;
  pointer-events: auto;
  cursor: pointer;
  border-radius: 9999px;
  -webkit-appearance: none; }
`, "",{"version":3,"sources":["webpack://./src/components/RangeSlider/range.scss"],"names":[],"mappings":"AAeA;EAEI,aAdsB;EAetB,cAfsB;EAIxB,yBAPqD;EAQrD,yBAP8C;EAQ9C,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,wBAAwB,EAAA;;AAG1B;EAOI,WAlBiB;EAmBjB,YAnBiB;EAGnB,yBAPqD;EAQrD,yBAP8C;EAQ9C,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,wBAAwB,EAAA","sourcesContent":["$thumb-background-color: theme(\"colors.purple.lighter\");\n$thumb-border-color: theme(\"colors.purple.base\");\n$thumb-border-width: 4px;\n$thumb-size-webkit: 1.5rem;\n$thumb-size-moz: 1rem;\n\n@mixin thumb-styles {\n  background-color: $thumb-background-color;\n  border: $thumb-border-width solid $thumb-border-color;\n  pointer-events: auto;\n  cursor: pointer;\n  border-radius: 9999px;\n  -webkit-appearance: none;\n}\n\n.range {\n  input[type=\"range\"]::-webkit-slider-thumb {\n    width: $thumb-size-webkit;\n    height: $thumb-size-webkit;\n    @include thumb-styles();\n  }\n  input[type=\"range\"]::-moz-range-thumb {\n    width: $thumb-size-moz;\n    height: $thumb-size-moz;\n    @include thumb-styles();\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
